require('../../modules/es6.object.is-extensible');
module.exports = require('../../modules/_core').Object.isExtensible;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/is-extensible.js
// module id = 255
// module chunks = 31